import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import UserProfile, { validName } from '../records/UserProfile';
import BlankNameModal from '../components/BlankNameModal';
import { getCurrentUserProfile } from '../selectors/EntitySelector';
import { updateBlankProfile } from '../actions/ProfileActions';
import { jsx as _jsx } from "react/jsx-runtime";
class BlankNameModalContainer extends Component {
  constructor(props) {
    super(props);
    const {
      profile
    } = this.props;
    this.state = {
      stagedFirstName: profile.get('firstName') || '',
      stagedLastName: profile.get('lastName') || ''
    };
    this.onSaveName = this.onSaveName.bind(this);
    this.onStagedFirstNameChanged = this.onStagedFirstNameChanged.bind(this);
    this.onStagedLastNameChanged = this.onStagedLastNameChanged.bind(this);
  }
  onStagedFirstNameChanged(evt) {
    this.setState({
      stagedFirstName: evt.target.value
    });
  }
  onStagedLastNameChanged(evt) {
    this.setState({
      stagedLastName: evt.target.value
    });
  }
  onSaveName() {
    const {
      profile
    } = this.props;
    const {
      stagedFirstName,
      stagedLastName
    } = this.state;
    this.props.updateBlankProfile(profile.merge({
      firstName: stagedFirstName,
      lastName: stagedLastName
    }));
  }
  render() {
    const {
      stagedFirstName,
      stagedLastName
    } = this.state;
    return /*#__PURE__*/_jsx(BlankNameModal, {
      stagedFirstName: stagedFirstName,
      stagedLastName: stagedLastName,
      onSaveName: this.onSaveName
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      onEditName: this.onEditName,
      validFirstName: validName(stagedFirstName),
      validLastName: validName(stagedLastName),
      onStagedFirstNameChanged: this.onStagedFirstNameChanged,
      onStagedLastNameChanged: this.onStagedLastNameChanged
    });
  }
}
BlankNameModalContainer.propTypes = {
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  updateBlankProfile: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    profile: getCurrentUserProfile(state)
  };
};
export default connect(mapStateToProps, {
  updateBlankProfile
})(BlankNameModalContainer);